import { html, type TemplateResult } from 'lit';
import { iconPixelArrowUp } from '../../icons';
import '../app-button/app-button';

export interface AppFooterProps {
  onScrollToTop?: () => void;
}

export function renderAppFooterPresentation(props: AppFooterProps = {}): TemplateResult {
  const { onScrollToTop } = props;

  return html`
    <footer class="site-footer">
      <div class="footer-meta">
        Geireann Lindfield Roberts • portfolio.v3
      </div>
      <app-button
        variant="text"
        label="Top"
        @click=${onScrollToTop}
      >
        <span slot="icon-right" style="margin-left: 0.2rem;">${iconPixelArrowUp(12)}</span>
      </app-button>
    </footer>
  `;
}
